import { formatEuro } from '@doveit/hammer';
import * as Yup from 'yup';

export default (minTarget: number) => Yup.object().shape({
  target: Yup
    .number()
    .min(minTarget, `Il tuo obiettivo deve essere di almeno ${formatEuro(minTarget)}`)
    .required("Devi inserire l'importo del tuo obiettivo"),
});
